<template>
  <div
    style="position: relative"
    class="user-item pa-1"
    :class="{
      'grey lighten-4':
        !(
          ['foodguru', 'cityfresh'].includes($store.state.livechat.theme) ||
          ['100207768987988'].includes($store.state.livechat.pageid)
        ) && user.adminread == false,
      'grey lighten-3': selected,
      'red lighten-3': $aston.astonpages.includes($store.state.livechat.pageid) && !user.adminread,
      'brown lighten-3': ['foodguru'].includes($store.state.livechat.theme) && !user.adminread,
      'red lighten-3 white--text':
        ['100207768987988'].includes($store.state.livechat.pageid) && !user.adminreply,
      'dark-style': ['cityfresh'].includes($store.state.livechat.theme)
    }"
    :style="customBackgroudStyle"
  >
    <v-list-tile avatar class="px-0">
      <v-list-tile-avatar>
        <template v-if="user.profile_pic">
          <img class="profile" :src="user.profile_pic" alt @error="imgError(this)" />
        </template>
        <template v-else>
          <img class="profile" src="/static/img/assets/livechat/profile.png" alt />
        </template>
      </v-list-tile-avatar>
      <v-list-tile-content>
        <v-list-tile-title
          :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
          v-if="
            [
              '103267601317473',
              '208321456497173',
              '103235014977289',
              ...$store.state.rabbitPage
            ].includes(selectedBot.pageid)
          "
          :class="{ unreadmessage: !user.adminread }"
          >{{ userRealname }}</v-list-tile-title
        >
        <v-list-tile-title
          :style="$vuetify.breakpoint.mdAndUp && `font-size: 13px`"
          v-else
          :class="{ unreadmessage: !user.adminread }"
        >
          {{ `${user.first_name} ${user.last_name}`
          }}{{ selectedBot.type == 'hopinnhr' && user.memberid ? `(${user.memberid})` : '' }}
        </v-list-tile-title>

        <!-- Last message -->
        <!-- For AIS\Hippo -->

        <template
          v-if="
            (['foodguru'].includes($store.state.livechat.theme) ||
              ['100207768987988'].includes($store.state.livechat.pageid)) &&
            !user.adminread
          "
        >
          <v-list-tile-sub-title
            class="caption"
            :class="{
              unreadmessage: !user.adminread
            }"
          >
            {{ user.lastmessage | fmMessage }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title class="caption col-6" :class="{ unreadmessage: !user.adminread }">
            {{ dayLeft(user.lastreply_time) }}
          </v-list-tile-sub-title>
        </template>
        <template v-else>
          <v-list-tile-sub-title
            class="caption"
            :class="{
              unreadmessage: !user.adminread,
              'black--text':
                ['cityfresh'].includes($store.state.livechat.theme) ||
                ['dentalhub'].includes(selectedBot.type),
              ' grey--text text--lighten-1':
                !['cityfresh'].includes($store.state.livechat.theme) &&
                !['dentalhub'].includes(selectedBot.type)
            }"
          >
            {{ user.lastmessage | fmMessage }}
          </v-list-tile-sub-title>

          <v-list-tile-sub-title
            class="caption"
            :class="{
              unreadmessage: !user.adminread,
              'black--text':
                ['cityfresh'].includes($store.state.livechat.theme) ||
                ['dentalhub'].includes(selectedBot.type),
              ' grey--text text--lighten-1':
                !['cityfresh'].includes($store.state.livechat.theme) &&
                !['dentalhub'].includes(selectedBot.type)
            }"
          >
            {{ dayLeft(user.lastreply_time) }}
          </v-list-tile-sub-title>
        </template>
      </v-list-tile-content>
      <template v-if="['dentalhub'].includes(selectedBot.type)">
        <v-list-tile-action>
          <span style="color: #3b5998" v-if="user.app === 'facebook'">
            <em class="fab fa-facebook-square" />
          </span>
          <span style="color: #00c300" v-else-if="user.app === 'line'">
            <em class="fab fa-line" />
          </span>
          <span style="color: #ff0069" v-else-if="user.app === 'instagram'">
            <em class="fab fa-instagram" />
          </span>
        </v-list-tile-action>
      </template>
    </v-list-tile>

    <div v-if="currentTheme == 'scgallrent'" class="text-xs-right">
      <v-chip v-if="user.status == 'Customer&Supplier'" small color="red" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Customer'" small color="blue" dark class="caption">{{
        user.status
      }}</v-chip>
      <v-chip v-else-if="user.status == 'Supplier'" small color="orange" dark class="caption">{{
        user.status
      }}</v-chip>
    </div>

    <div
      v-if="user.status && ['148559413337'].includes(selectedBot.pageid)"
      class="text-xs-right"
      style="position: absolute; right: 0px; bottom: 0px"
    >
      <v-chip small color="primary" dark class="caption">{{ user.status }}</v-chip>
    </div>
    <div
      v-if="
        ['ticket2', 'studio7', 'ustore'].includes(currentTheme) ||
        selectedBot.pageid == '100207768987988' ||
        $store.state.ticketPageid.includes(selectedBot.pageid)
      "
    >
      <div
        v-if="
          (selectedBot.pageid == '100207768987988' &&
            user.tickets &&
            user.tickets.length > 0 &&
            user.hasOwnProperty('tickets')) ||
          ((['ticket2', 'studio7', 'ustore'].includes(currentTheme) ||
            $store.state.ticketPageid.includes(selectedBot.pageid)) &&
            user.tickets &&
            user.tickets.length > 0 &&
            user.hasOwnProperty('tickets'))
        "
      >
        <v-layout row wrap class="ma-0">
          <v-flex xs7>
            <div class="caption pt-2 pl-2" style="word-break: break-all">
              <v-icon small class="mr-1">person</v-icon>{{ user.tickets[0][1] }}
            </div>
          </v-flex>
          <v-flex xs5 class="text-xs-right">
            <!-- Ticket Status -->
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-chip
                  @click="showEditTicket2Status"
                  small
                  :color="ticketColorStatus(user.tickets[0][2])"
                  dark
                  class="caption"
                  alt="Ticket Status"
                  v-on="on"
                >
                  {{ user.tickets[0][2] }} <v-icon small class="ml-1"> arrow_drop_down</v-icon>
                </v-chip>
              </template>
              <span>Ticket Status</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </div>
    </div>
    <div v-if="['dtac-gaming'].includes(selectedBot.type) && user.tags">
      <v-layout wrap>
        <v-flex xs12 class="text-xs-right">
          <v-chip small color="primary" dark class="caption">{{ user.tags }}</v-chip>
        </v-flex>
      </v-layout>
    </div>
    <div v-if="$store.state.kfcpage.includes(selectedBot.pageid)" class="caption pt-2 pl-2">
      {{ user.temp_msg }}
    </div>
    <div
      v-if="
        (currentTheme == 'ticket' || $store.state.ticketPageid.includes(selectedBot.pageid)) &&
        user.status
      "
      class="text-xs-right"
      :style="'position: block; right: 0px; bottom: 0px'"
    >
      <template v-if="[...$store.state.bbqPage].includes(selectedBot.pageid)">
        <v-chip
          v-if="user.status"
          small
          :color="handleBbqGetStatusColor(user.status)"
          dark
          class="caption"
          >{{ user.status }}</v-chip
        >
      </template>
      <template v-else>
        <v-chip v-if="user.status == 'cancelled'" small color="error" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else-if="user.status == 'closed'" small color="grey" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else-if="user.status == 'pendding'" small color="warning" dark class="caption">{{
          user.status
        }}</v-chip>
        <v-chip v-else small color="primary" dark class="caption">{{ user.status }}</v-chip>
      </template>
    </div>
    <div v-if="['dentalhub'].includes(selectedBot.type) && user.tickets && user.tickets.length > 0">
      <v-layout wrap>
        <v-flex>
          <div class="caption pt-2 pl-2" style="word-break: break-all">
            <v-icon small class="mr-1">person</v-icon>
            <span class="primary--text">{{ user.tickets[0][1] }}</span>
          </div>
        </v-flex>
        <v-flex class="text-xs-right">
          <v-chip
            small
            :color="ticketColorStatus(user.tickets[0][2])"
            dark
            class="caption"
            alt="Ticket Status"
          >
            {{ user.tickets[0][2] }}
          </v-chip>
        </v-flex>
      </v-layout>
    </div>
    <div>
      <v-dialog
        content-class="nooverflow"
        class="dialog-nooverflow"
        v-model="ticket2Modal"
        width="400px"
        persistent
        style="overflow-y: none !important"
      >
        <v-card class="pa-3">
          <div class="mb-3" style="font-size: 21px; font-weight: 600">Change status</div>
          <div>
            <multiselect
              v-model="input.ticket2status"
              tag-placeholder="Add this as new tag"
              placeholder="Status"
              :searchable="false"
              :options="optionsStatus"
              :show-labels="false"
            ></multiselect>
          </div>
          <div class="text-xs-center mt-2">
            <v-btn @click="ticket2Modal = false" outline color="grey">Cancel</v-btn>
            <v-btn :loading="saveloading" @click="saveTicket2Status" depressed color="primary"
              >Save</v-btn
            >
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'
import Multiselect from 'vue-multiselect'
import api from '@/api'
export default {
  props: ['value', 'selected'],
  data: function () {
    return {
      user: {},
      saveloading: false,
      input: {
        ticket2status: ''
      },
      hasNewMessage: false,
      ticket2Modal: false,
      optionsStatus: ['Pending', 'Answered', 'Cancel', 'Closed']
    }
  },
  async mounted() {
    if (this.value) {
      this.user = this.value
    }
  },
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['selectedBot', 'livechat']),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    },
    userRealname: {
      get() {
        if (this.value && this.value.realname) {
          return this.value.realname
        } else
          return (
            (this.value.first_name ? this.value.first_name : '') +
            (this.value.last_name ? ' ' + this.value.last_name : '')
          )
      },
      set(val) {
        this.value.realname
      }
    },
    customBackgroudStyle() {
      if (this.$store.state.kfcpage.includes(this.selectedBot.pageid)) {
        if (this.user.status == 'ลูกค้ารอ') {
          return { backgroundColor: 'rgb(211 255 206) !important' }
        } else if (this.user.status == 'ตอบแล้ว') {
          return { backgroundColor: 'rgb(255 220 220) !important' }
        }
      } else if (['cityfresh'].includes(this.selectedBot.theme)) {
        if (this.user && this.user.adminread) {
          return { color: '#000 !important' }
        } else {
          return { backgroundColor: '#C3D9A7 !important', color: '#000 !important' }
        }
      } else if (['dentalhub'].includes(this.selectedBot.type)) {
        if (this.user && this.user.adminread) {
          return { color: '#000 !important' }
        } else {
          return { backgroundColor: '#d3ffce !important', color: '#000 !important' }
        }
      }
    }
  },
  filters: {
    time: function (date) {
      if (typeof date === 'string') {
        date = moment(date)
      }
      return date.format('h:mm A')
    }
  },

  methods: {
    saveTicket2Status() {
      var data = {
        pageid: this.$store.state.livechat.pageid,
        status: this.input.ticket2status.toLowerCase(),
        ticketId: this.user.tickets[0][0]
      }
      this.saveloading = true
      api.ticket2UpdateTicket(data, (err, response) => {
        this.saveloading = false
        this.user.tickets[0][2] = this.input.ticket2status
        this.ticket2Modal = false
      })
    },
    showEditTicket2Status() {
      this.input.ticket2status = this.user.tickets[0][2]
      this.ticket2Modal = true
    },
    ticketColorStatus(val) {
      switch (val.trim().toLowerCase()) {
        case 'pending':
          return '#fb8c00'
        case 'closed':
          return '#e0e0e0'
        case 'cancelled':
          return '#ff5252'
        case 'cancelled by customer':
          return '#fd87ee'
        case 'answered':
          return '#2196f3'
        case 'open':
          return '#4CAF50'
        default:
          return ''
      }
    },

    handleBbqGetStatusColor(status) {
      const bbqStatusColor = this.$store.state.bbqStatusColor
      const filterStatus = bbqStatusColor.find((el) => {
        return el.status === status
      })

      return filterStatus ? filterStatus.color : 'primary'
    },
    imgError: function (event, el) {
      // console.log('not load')
      this.value.profile_pic = '/static/img/assets/livechat/profile.png'
    },
    dayLeft: function (replytime) {
      let lastreply = moment(replytime)
      let currentDate = moment()

      let time = ''
      if ([...this.$store.state.bbqPage].includes(this.selectedBot.pageid)) {
        time = lastreply.format('DD MMM YYYY HH:mm')
      } else {
        if (currentDate.diff(lastreply, 'days') > 0) {
          time = lastreply.format('DD MMM YYYY')
        } else if (currentDate.diff(lastreply, 'hours') > 0) {
          time = currentDate.diff(lastreply, 'hours')
          time += ' ' + this.$t('Hours')
        } else if (currentDate.diff(lastreply, 'minutes') > 0) {
          time = currentDate.diff(lastreply, 'minutes')
          time += ' ' + this.$t('Minutes')
        } else if (currentDate.diff(lastreply, 'seconds') > 0) {
          time = currentDate.diff(lastreply, 'seconds')
          time += ' ' + this.$t('Seconds')
        }
      }
      return time
    }
  },
  watch: {
    value: function (newVal, oldVal) {
      this.user = newVal
      if (newVal.lastreply_time != oldVal.lastreply_time) {
        if (this.selected != true) {
          this.hasNewMessage = true
        }
      }
    },
    selected: function (newVal, oldVal) {}
  },
  filters: {
    fmMessage(value) {
      if (value && value.startsWith('data:image')) {
        return 'image'
      } else {
        return value
      }
    }
  }
}
</script>

<style lang="scss">
.px-0 .v-list__tile {
  padding-left: 5px !important;
  padding-right: 2px !important;
}
.unreadmessage {
  color: black !important;
  font-weight: bold;
}
.dark-style {
  .v-list__tile__title {
    color: #000 !important;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/view/livechat/livechat-user-item.vue